// Recognises a returning customer and their previous instructor so the
// booking journey doesn't force them to pick an instructor from scratch
// (and doesn't silently hand them a different instructor than last time -
// see CR: "the same student ended up booking multiple instructors because
// the system did not properly recognise the previous instructor relationship").
//
// There is no backend endpoint that returns a customer's booking/instructor
// history by email for a not-yet-logged-in visitor, so this is a client-side
// (this-browser-only) memory: it remembers who a given email booked with last
// time, on this device. It is not account-level recognition across devices.

const STORAGE_KEY = 'pd_returning_customers';

const normalizeEmail = (email) => `${email || ''}`.trim().toLowerCase();

export function getPreviousInstructor(email) {
    const key = normalizeEmail(email);
    if (!key) return null;

    try {
        const all = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        return all[key] || null;
    } catch (e) {
        return null;
    }
}

export function rememberInstructorForEmail(email, instructor) {
    const key = normalizeEmail(email);
    if (!key || !instructor?.id) return;

    try {
        const all = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        all[key] = { id: instructor.id, name: instructor.name };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    } catch (e) {
        // localStorage unavailable (private mode, quota, etc.) - not critical, skip silently
    }
}
